// extracted by mini-css-extract-plugin
export default {"table":"QMASTable_table__MgRLC","noneBorder":"QMASTable_noneBorder__kvteE"};